import React from "react";
import { useState, useEffect } from "react";
import EditNotePopup from "./EditNotePopup";
import DeletePopup from "./DeletePopup";
import axios from "../../../../axios";
import { IP } from "../../../../internalServer";
import { iconData } from "../../../../iconData";
import assets from "../../../../assets/assets";
export default function Notes({ user, content }) {
  const [editPopUp, setEditPopUp] = useState(false);
  const [deletePopUp, setDeletePopUp] = useState(false);
  const [notesAttachment, setNotesAttachment] = useState([]);
  const [notesAttachmentId, setNotesAttachmentId] = useState([]);
  const [notesInput, setNotesInput] = useState("");
  const [contentNote, setContentNote] = useState([]);
  const [clickedNotes, setclickedNotes] = useState();
  const [attachMent2, setAttachment2] = useState([]);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [toViewIndex, setToViewIndex] = useState(null);
  const [componentRerenderFlag, setComponentRerenderFlag] = useState(false);

  function handleFileSelect(event) {
    const files = event.target.files;

    handleAttachment(files);
  }

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.pptx|\.ppt|\.doc|\.docx)$/i;

    if (!allowedExtensions.exec(filePath.name)) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  const handleAttachment = async (files) => {
    let attachments = [...notesAttachment];
    let attachmentId = [...notesAttachmentId];
    let totalSizeInBytes = attachMent2.reduce(
      (acc, file) => acc + file.size,
      0
    );
    let fileCount = attachMent2.length;

    if (files) {
      for (const file of files) {
        try {
          // Check if the file is already uploaded
          const isFileAlreadyUploaded = attachMent2.some(
            (uploadedFile) =>
              uploadedFile.name === file.name && uploadedFile.size === file.size
          );

          if (isFileAlreadyUploaded) {
            console.log("File already uploaded");
            setIsValidFileType(false);
            return;
          }
          if (
            fileCount < 5 &&
            totalSizeInBytes + file.size <= 10 * 1024 * 1024 &&
            validateFileType(file)
          ) {
            // const allowedTypes = [
            //   "application/pdf",
            //   "image/jpeg",
            //   "image/png",
            //   "audio/mpeg",
            //   "video/mp4",
            // ];
            // if (!allowedTypes.includes(file.type)) {
            //   window.alert(
            //     "Invalid file type. Only PDF, JPEG, PNG, MP3, and MP4 files are allowed."
            //   );
            //   continue;
            // }
            // const maxSizeInMB = file.type.startsWith("image")
            //   ? 5
            //   : file.type === "audio/mpeg"
            //   ? 50
            //   : 250;
            // const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
            // if (
            //   file.type === "application/pdf" &&
            //   file.size > 50 * 1024 * 1024
            // ) {
            //   window.alert("PDF file size exceeds 50 MB.");
            //   continue;
            // } else if (file.size > maxSizeInBytes) {
            //   window.alert(`File size exceeds ${maxSizeInMB} MB.`);
            //   continue;
            // }
            let formData = new FormData();
            formData.append("name", file.name);
            formData.append("content", file);
            let res = await axios.post(
              `/school/library/uploadFile?module_name=studentNotes`,
              formData
            );
            res && attachments.push(res.data.data);
            res && attachmentId.push(res.data.data.id);
            setAttachment2((prev) => [...prev, file]);
          } else {
            setIsValidFileType(false);
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (attachments.length > 0) {
        setNotesAttachment(attachments);
        setNotesAttachmentId(attachmentId);
      }
    }
  };
  const handleremove = (indexToRemove) => {
    if (indexToRemove >= 0 && indexToRemove < notesAttachment.length) {
      const updatedAttachments = [...notesAttachment];
      const updatedAttachments1 = [...notesAttachmentId];
      if (attachMent2 && attachMent2.length > 0) {
        const newArrayLimit = [...attachMent2];
        newArrayLimit.splice(indexToRemove, 1);
        setAttachment2(newArrayLimit);
      }
      updatedAttachments.splice(indexToRemove, 1);
      updatedAttachments1.splice(indexToRemove, 1);
      setNotesAttachment(updatedAttachments);
      setNotesAttachmentId(updatedAttachments1);
    }
  };
  const handleCreateNotes = () => {
    const helper = async () => {
      let body = {
        user_id: user?.id,
        contentInfo_id: content?.id,
        noteText: notesInput,
        fileInfoIds: notesAttachmentId,
      };
      let res = await axios.post(
        `/cm/library/book/createUserNotesByUserIDAndContentInfoID`,
        body
      );
      if (res.status === 200) {
        // window.location.reload();
        setComponentRerenderFlag((prevFlag) => !prevFlag);
        setNotesInput("");
        setNotesAttachment([]);
        setAttachment2([]);
        setNotesAttachmentId([]);
      }
    };
    helper();

  };
  useEffect(() => {
    const helper = async () => {
      setContentNote([]);
      if (user?.id && content?.id) {
        let res = await axios.get(
          `/cm/library/book/getUserNotesByUserIDAndContentInfoID?user_id=${user?.id}&contentInfo_id=${content?.id}`
        );
        res && setContentNote(res?.data?.data?.notesID);
      }
    };
    if (content) {
      helper();
    }
  }, [content, user, componentRerenderFlag]);

  const urlhelper = (a) => {
    const str = a;
    const startsWithDot = str?.startsWith(".");
    if (startsWithDot) {
      let p = a.replace(/^\./, "");
      p = IP + p;
      return p;
    } else {
      return a;
    }
  };

  function calculateDaysAgo(createdAt) {
    const createdAtDate = new Date(createdAt);
    const currentDate = new Date();
    const timeDifference = currentDate - createdAtDate;
    const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    return daysAgo;
  }

  return (
    <div className="mt-3 noteEditter" >
      <div className="totalContainerNoteView p-3" >
        <div className="d-flex justify-content-between align-items-center">
          <div className="CreateNote">Create Notes</div>
          <div className="mr-2 pt-1 ">
            <input
              type="file"
              id="attachFile"
              accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx,.mp3,.mp4"
              style={{ display: "none" }}
              onChange={(e) => {
                handleFileSelect(e);
                e.target.value = null;
              }}
            />
            <label htmlFor="attachFile">
              <img
                style={{ cursor: "pointer" }}
                src={assets.UploadIcon}
                className="w-10"
                alt="Attachment icon"
              />
            </label>
          </div>
        </div>
        {!isValidFileType && (
          <p id="errorMsg">
            "Exceeded Limit !!
            Max 5 attachments and total of 10 MB size is allowed."
          </p>
        )}
        <div>
          <textarea
            placeholder="Type here to create notes..."
            className="inputeForNote mt-2 mb-1"
            value={notesInput}
            onChange={(e) => {
              setNotesInput(e.target.value);
            }}
            maxLength={500}
          />
        </div>

        <div className="d-flex justify-content-end gap-3 mt-2 overflow">
          <div className="d-flex gap-2 align-items-center overflow">
            {notesAttachment.map((obj, index) => (
              <>
                <div>
                  <img src="/LibraryImg/JpgIcon.png" alt="" />
                </div>
                <div className="UplodedimgName">{obj?.fileName}</div>
                <div className="ml-2">
                  <img
                    src="/LibraryImg/CrossPdf.png"
                    alt=""
                    onClick={() => {
                      handleremove(index);
                    }}
                  />
                </div>
              </>
            ))}
          </div>
          <button
            className={notesInput !== "" ? "postBtnNote" : "postBtnNoteDisable"}
            disabled={notesInput !== "" ? false : true}
            onClick={() => {
              handleCreateNotes();
            }}
          >
            Post

          </button>
        </div>
      </div>
      <div className="CreateNote mt-3">View Previous Notes</div>
      {contentNote?.length > 0 &&
        contentNote.map((obj, index) => (
          <>
            <div
              className={

                index === toViewIndex
                  ? "totalContainerNoteView mt-3"
                  : "totalContainerNote mt-3 "
              }
              style={{ display: "flex", justifyContent: "space-between", alignContent: "center" }}
            >
              <div
                className={
                  index === toViewIndex ? "noteColorView" : "noteColor"
                }
              >
                {obj?.notesText}
              </div>
              <div className="d-flex gap-4 justify-content-end ">
                {obj.noteFileInfo.length > 0 &&
                  obj.noteFileInfo.map((obj, index) => (
                    <>
                      <a href={urlhelper(obj?.fileURL)} target="_blank" className="d-flex text-decoration-none justify-content-center align-items-center">
                        <img
                          src={`${iconData?.find((i) => i.extension === obj.fileType)
                            ?.icon
                            }`}
                          alt=""
                          style={{ maxHeight: "16px", maxWidth: "16px" }}
                        />
                        <div className="UplodedimgName ms-2 mt-1">{obj?.fileName}</div>
                      </a>
                      <div className="ml-2">
                      </div>
                    </>
                  ))}
                <span className="daysAgo">
                  {calculateDaysAgo(obj.updatedAt) === 0
                    ? "Today"
                    : `${calculateDaysAgo(obj.updatedAt)} Days ago`}
                </span>
                <span
                  className="editeNote"
                  onClick={(e) => {
                    setEditPopUp(true);
                    setclickedNotes(obj);
                  }}
                >
                  Edit
                </span>
                <span
                  className="Deletenote"
                  onClick={(e) => {
                    setDeletePopUp(true);
                    setclickedNotes(obj);
                  }}
                >
                  Delete
                </span>
                {/* Hide view button */}
                {/* <span
                  className="viewNote"
                  onClick={(e) => {
                    if (index === toViewIndex) {
                      setToViewIndex(null);
                    } else {
                      setToViewIndex(index);
                    }
                  }}
                >
                  {index === toViewIndex ? "View Less" : "View"}
                </span> */}
              </div>
            </div>
          </>
        ))}
      {editPopUp && (
        <EditNotePopup
          handleCloseNoteEditPopup={() => {
            setEditPopUp(false);
          }}
          data={clickedNotes}
          userData={user}
          contentId={content}
          setComponentRerenderFlag={setComponentRerenderFlag}
          setNotesInput={setNotesInput}
          setNotesAttachment={setNotesAttachment}
          setAttachment2={setAttachment2}
          setNotesAttachmentId={setNotesAttachmentId}
        />
      )}
      {deletePopUp && (
        <DeletePopup
          handleCloseNoteDeltePopup={() => {
            setDeletePopUp(false);
          }}
          setComponentRerenderFlag={setComponentRerenderFlag}
          data={clickedNotes}
          userData={user}
          contentId={content?.id}
        />
      )}
    </div>
  );
}
